import {getLocal} from "../hooks/useStorage/useStorage.jsx"

const getMenu = async () => {
    const authkey = getLocal('authkey')
    const idStore = getLocal('idStore')
    const indexStore = getLocal('indexStore')
    const url = `${import.meta.env.VITE_GET_MENU}?authkey=${authkey}&id=${idStore}&index=${indexStore}`
    console.log(url)
    const res = await fetch(url)
    return await res.json()
}

const getLastMenu = async () => {
    const authkey = getLocal('authkey')
    const idStore = getLocal('idStore')
    const indexStore = getLocal('indexStore')
    const url = `${import.meta.env.VITE_GET_LAST_MENU}?authkey=${authkey}&id=${idStore}&index=${indexStore}`
    const res = await fetch(url)
    return await res.text()
}

const sendOrder = async requestData => {
    const url = `${import.meta.env.VITE_SEND_REQUEST}/pedido`
    const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(requestData)
    })
    return await res.json()
}

const deleteOrder = async id => {
    const url = `${import.meta.env.VITE_SEND_REQUEST}/pedido?id=${id}`
    const res = await fetch(url, {
        method: 'DELETE'
    })
    return await res.json()
}

const getDiscountCoupon = async (discountCoupon) => {
    const url = `${import.meta.env.VITE_GET_COUPON}?authkey=${import.meta.env.VITE_AUTHKEY}&id=${import.meta.env.VITE_ID_STORE}&cupom=${discountCoupon}`
    const res = await fetch(url)
    return await res.json()
}

const sendLog = async (body, method = 'POST') => {
    const url = `${import.meta.env.VITE_SEND_REQUEST}/logs`
    const res = await fetch(url, {
        method: method,
        body: body
    })
    return await res.json()
}

const getLog = async id => {
    const url = `${import.meta.env.VITE_SEND_REQUEST}/logs/?authkey=${import.meta.env.VITE_AUTHKEY}&id=${id}`
    const res = await fetch(url, {
        method: 'GET'
    })
    return await res.json()
}

const getCashback = async (cpf, gularisToken) => {
    const url = `https://app.gularis.com.br/api/v1/consumidores/saldo?cpf=${cpf}`
    const res = await fetch(url, {
        method: 'GET',
        headers: {
            'Token-Loja': `${gularisToken}`,
        }
    })
    return await res.json()
}

const getConsultation = async (pix = false, comandas, tipo_pedido, transactionID) => {
    const data = {
        consulta: {
            authkey: import.meta.env.VITE_AUTHKEY,
            id_loja: import.meta.env.VITE_ID_STORE,
            pix: pix,
            comandas: comandas,
            tipo_pedido: tipo_pedido,
            transactionID: transactionID
        }
    }
    const url = `${import.meta.env.VITE_SEND_REQUEST}/consulta`
    const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data)
    })
    return await res.json()
}

const sendPayment = async (data) => {
    const url = `${import.meta.env.VITE_SEND_REQUEST}/pagamento`
    const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data)
    })
    return await res.json()
}

export {
    getMenu,
    getLastMenu,
    sendOrder,
    deleteOrder,
    getDiscountCoupon,
    getLog,
    sendLog,
    getCashback,
    getConsultation,
    sendPayment
}
